import { useEffect, useState } from "react";

/**
 * Delays updating the returned value until `delay` ms have passed
 * without the input changing. Useful for search inputs + Apollo queries.
 *
 * Usage:
 *   const debouncedSearch = useDebounce(searchValue, 300);
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}